import MenuNames from "../../../constants/Menu/MenuNames.json";
import BulkUploadDriverProperties from "../../../views/BulkUploadDriverProperties";

const BulkUploadDriverPropertiesRoutes = [
  {
    menuName: MenuNames.SLOT_CAPACITY_UPDATE,
    path: "/bulk-upload-driver-properties",
    component: BulkUploadDriverProperties,
    exact: true,
  },
];

export default BulkUploadDriverPropertiesRoutes;
